export default {
  persons: [],
  options: {},
  filters: {}
};
